import { RootState } from 'src/store';

export const userSelector = (state: RootState) => state.user;

export const isDriverUserSelector = (state: RootState) => {
  const { user } = state;
  return user?.info?.role === 'DRIVER';
};

export const isAgentUserSelector = (state: RootState) => {
  const { user } = state;
  return user?.info?.role === 'AGENT';
};

export const isSuperAdminUserSelector = (state: RootState) => {
  const { user } = state;
  return user?.info?.role === 'SUPPERADMIN';
};

export const isPartnerUserSelector = (state: RootState) => {
  const { user } = state;
  return user?.info?.role === 'PARTNER';
};

export const isAdminUserSelector = (state: RootState) => {
  const { user } = state;
  return user?.info?.role === 'ADMIN';
};
